import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

const CardView = () => {
  const { username } = useParams();
  
  // Redirect to bio page
  return <Navigate to={`/bio/${username}`} replace />;
};

export default CardView;
